<template>
  <div v-if="teeth.length > 0 && !readOnly">
    <ToothGroupServiceSelector :label="$t('add_service')"
                               :allowDropdownAbove="allowDropdownAbove"
                               :insuranceCompanyId="insuranceCompanyIdForAutocomplete"
                               :showSelectedBlock="showSelectedBlock"
                               :teeth="teethObjects"
                               class="add-material-input"
                               @select="serviceAdded">
      <ServicesFromPriceBlock v-if="showSelectFromPrice"
                              @selected="(_services) => servicesAdded(_services)"/>
    </ToothGroupServiceSelector>
    <slot/>
  </div>
</template>

<script setup>
import {computed, inject} from "vue"
import {useStore} from "vuex"
import ToothGroupServiceSelector from "@/components/parts/patients/visit/teethTab/ToothGroupServiceSelector.vue"
import ServicesFromPriceBlock from "@/components/parts/patients/ServicesFromPriceBlock.vue"

defineProps({
  showSelectFromPrice: {
    type: Boolean,
    default: false
  },
  allowDropdownAbove: {
    type: Boolean,
    default: false
  },
  showSelectedBlock: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

const cannotChange = inject('cannotChange')
const cannotChangeServices = inject('cannotChangeServices')
const versionCount = inject('versionCount')

const teeth = computed(() => store.getters.recordTeeth)
const teethObjects = computed(() => store.getters.recordTeethObjects)
const visit = computed(() => store.state.patient.visit)
const insuranceCompanyIdForAutocomplete = computed(() => {
  return visit.value?.insurance_polis?.insurance_company_id || visit.value?.insurance_company_id || null
})

const readOnly = computed(() => cannotChange.value || cannotChangeServices.value)

const serviceAdded = async (service) => {
  if(readOnly.value || !service) return
  await store.dispatch('toggleServiceToToothNewVersion', {
    serviceId: service.id,
    qty: 1,
    sign: 'plus',
    scope: 'all_teeth',
    insuranceCompanyId: insuranceCompanyIdForAutocomplete.value
  })
  versionCount.value++
}

const servicesAdded = async (_services) => {
  for(const _service of _services) {
    await serviceAdded(_service)
  }
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 992px) {
  .add-material-input {
    min-width: 400px;
  }
}
</style>
